<template lang="pug">
UiPage(:title="$t('companies.title')")
  template(#actions)
    UiStack
      UiButton(
        @click="importCompanies"
        icon="FileUpload"
      ) {{ $t("companies.import") }}
      UiButton(
        @click="addCompany"
        icon="Plus"
      ) {{ $t("actions.add") }}
  .container
    UiCard
      UiCardSection
        RestTable(
          namespace="companies"
          ref="companiesTable"
          :headers="headers"
          :fetchHandler="getData"
          :initial-filters="initialFilters"
          embed
        )
          template(#filters="{ filters, updateFilters }")
            UiCardSection
              UiStack(align="end")
                UiStackItem
                  UiFormGroup(:label="$t('companies.basic.name')") 
                    UiInput#company-id-input(
                      :modelValue="filters.search"
                      @update:modelValue="updateFilters({ search: $event })"
                      type="search"
                      inputSize="40"
                    )
                UiStackItem
                  UiFormGroup(
                    :label="$t('companies.basic.netvisor_organization_id')"
                  ) 
                    UiInput#business-id-input(
                      :modelValue="filters.netvisor_organization_id"
                      type="search"
                      @update:modelValue="updateFilters({ netvisor_organization_id: $event })"
                      inputSize="40"
                    )
          template(#cell:company_name="{ item }")
            RouterLink(
              :to="`/companies/${item.id}/edit`"
              label="item.company_name"
              v-if="checkRights(item)"
            )
              | {{ item.company_name }}
            span(v-else) {{ item.company_name }}
          template(#cell:actions="{ item }")
            UiStack(spacing="xs")
              UiStackItem
                UiButton(
                  size="sm"
                  variant="smooth-primary"
                  icon="ListChecks"
                  :to="`/companies/${item.id}/edit?tab=reports`"
                ) {{ $t("companies.reports.title") }}
              UiStackItem(v-if="item.has_basware")
                UiButton(
                  size="sm"
                  variant="smooth-primary"
                  icon="Copy"
                  @click="cloneBasware(item)"
                ) {{ $t("companies.clone") }}
              UiStackItem
                UiButton(
                  size="sm"
                  variant="smooth-danger"
                  icon="Trash"
                  @click="deleteCompany(item)"
                ) {{ $t("actions.delete") }}
  CreateCompanyModal(
    ref="CompanyCreateModal"
    @done="reloadList"
  )
  ImportCompanyModal(
    ref="CompanyImportModal"
    @done="reloadList"
  )
  CloneBaswareCompanyModal(
    ref="BaswareCloneCompanyModal"
    @done="reloadList"
  )
</template>

<script>
import ApiCompanies from "@/api/companies.js";
import CreateCompanyModal from "@/modals/Companies/create.vue";
import ImportCompanyModal from "@/modals/Companies/import.vue";
import CloneBaswareCompanyModal from "@/modals/Companies/cloneBasware.vue";

export default {
  components: {
    CreateCompanyModal,
    ImportCompanyModal,
    CloneBaswareCompanyModal,
  },

  data() {
    return {
      initialFilters: {
        netvisor_organization_id: "",
      },
      headers: [
        {
          key: "company_name",
          label: "Name",
          sortable: true,
          width: "55%",
        },
        {
          key: "netvisor_organization_id",
          label: "BusinessId",
          sortable: true,
        },
        {
          key: "actions",
          label: "",
          squeeze: true,
        },
      ],
    };
  },
  methods: {
    reloadList() {
      this.$refs.companiesTable.fetchData();
    },

    getData(params, config) {
      return ApiCompanies.fetchCompanies(params, config).then((resp) => {
        return {
          items: resp.data.companies,
          meta: resp.data.meta,
        };
      });
    },

    addCompany() {
      this.$refs.CompanyCreateModal.open(null);
    },

    deleteCompany(item) {
      this.$dialogConfirm({
        title: this.$t("actions.remove"),
        description: this.$t("actions.confirm_remove"),
        variant: "danger",
        icon: "briefcase-remove",
        okLabel: this.$t("actions.remove"),
        okVariant: "danger",
        okIcon: "Trash",
        cancelVariant: "smooth-secondary",
      }).then((result) => {
        if (!result) return;
        ApiCompanies.deleteCompany(item.id).then((resp) => {
          this.reloadList();
        });
      });
    },

    importCompanies() {
      this.$refs.CompanyImportModal.open();
    },

    cloneBasware(item) {
      this.$refs.BaswareCloneCompanyModal.open(item);
    },

    checkRights(item) {
      if (
        window.user.role === "super_admin" ||
        window.user.role === "reseller"
      ) {
        return true;
      }
      let company = window.user.companies.find(
        (company) => company.id === item.id,
      );
      return !!company && company.role === "admin";
    },
  },
};
</script>
